const HTML_TAG_REGEX = /<[a-z][\s\S]*>/i;

const escapeHtml = (value: string) =>
  value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

/**
 * Prepare deviation result/action text for HTML display.
 * Quill-saved content is returned as-is; plain text is escaped and
 * newlines become <br> so older records still render correctly.
 */
export const toDisplayHtml = (value: string | null | undefined): string => {
  if (!value) return '';

  if (HTML_TAG_REGEX.test(value)) {
    return value;
  }

  return escapeHtml(value).replace(/\n/g, '<br>');
};
